import React, { Component } from 'react'

import './TopBar.css'

export class TopBar extends Component {
  render() {
    return (
      <div className="topBar">
        <h1> Spyfall </h1>
      </div>
    )
  }
}



export default TopBar
